const translations = {
  pt: {
    // Header
    appTitle: 'EcooGPS Planner',
    appSubtitle: 'Planeador de Rotas',
    headerSaveRoute: 'Guardar Rota',
    headerFullscreen: 'Ecrã inteiro',
    stops: 'Paragens',
    // Sidebar tabs
    tabRoute: 'Rota',
    tabVehicle: 'Veículo / Motorista',
    tabStops: 'Paragens',
    tabSaved: 'Gravadas',
    // Route form
    origin: 'Origem',
    destination: 'Destino',
    addWaypoint: 'Adicionar Paragem Intermédia',
    waypoint: 'Ponto Intermédio',
    calculateRoute: 'Calcular Rota',
    clearRoute: 'Limpar Rota',
    undo: 'Desfazer',
    routeName: 'Nome da Rota',
    cargoRef: 'Referência da Carga / Guia',
    departureTime: 'Hora de Partida',
    routePoints: 'Locais na Rota',
    routeOriginLabel: 'Rota Origem',
    routeDestLabel: 'Destino',
    roundTrip: 'Ida e Volta',
    clickMapOrigin: 'Clique no mapa para definir origem',
    clickMapDestination: 'Clique no mapa para definir destino',
    routeOptionsTitle: 'Opções de Rota',
    currencyCosts: 'Moeda dos custos',
    fuel: 'Combustível',
    fuelDiesel: 'Gasóleo',
    fuelGasoline: 'Gasolina',
    pricePerLitre: 'Preço por litro',
    vehicleTypeLbl: 'Tipo de veículo',
    vehicleHGV: 'Camião HGV',
    vehicleCar: 'Ligeiro',
    truckDimensions: 'Dimensões do camião',
    avoidSection: 'Evitar',
    avoidTolls: 'Portagens',
    avoidTollsTip: 'Evita estradas com portagem. Pode usar autoestradas gratuitas quando disponíveis.',
    avoidFerries: 'Travessias de barco',
    avoidMotorways: 'Autoestradas / IP',
    avoidMotorwaysTip: 'Evita autoestradas e vias de acesso controlado, independentemente de terem portagem. A rota usará estradas nacionais e regionais.',
    showAltRoutes: 'Mostrar rotas alternativas',
    showAltRoutesTip: 'Calcula até 2 rotas alternativas para comparação.',
    avoidUrbanAreas: 'Evitar centros urbanos',
    avoidCitiesWarning: 'Evitar cidades pode aumentar significativamente o tempo de viagem',
    recalculate: 'Recalcular',
    // Vehicle/Driver
    selectVehicle: 'Selecionar Veículo',
    selectDriver: 'Selecionar Motorista',
    vehicle: 'Veículo',
    driver: 'Motorista',
    plate: 'Matrícula',
    type: 'Tipo',
    capacity: 'Capacidade',
    licenseClass: 'Classe de Carta',
    tachoCard: 'Cartão Tacógrafo',
    // Stops list
    restStops: 'Paragens de Descanso',
    stopAt: 'Paragem em',
    driveTime: 'Tempo de Condução',
    stopDuration: 'Duração da Paragem',
    estimatedArrival: 'Chegada Estimada',
    euRegulation: 'Reg. UE 561/2006',
    totalDrivingTime: 'Tempo Total de Condução',
    totalRestTime: 'Tempo Total de Descanso',
    dailyLimit: 'Limite Diário',
    stopsCount: 'Nº Paragens',
    kmAtStop: 'Km na paragem',
    fetchingAddress: 'A obter morada...',
    calculateForStops: 'Calcule a rota para ver as paragens automáticas',
    basedOnRegulation: 'Baseado no Regulamento UE 561/2006',
    noStopsNeeded: 'Nenhuma paragem obrigatória necessária',
    within430: 'Duração dentro do limite de 4h30 de condução contínua',
    regulationNote: 'Após 4h30 de condução: pausa obrigatória de 45min (ou 15min + 30min)',
    stopBreak45: 'Pausa 45min',
    stopBreakSplit15: 'Pausa 15min',
    stopBreakSplit30: 'Pausa 30min',
    stopDailyRest: 'Descanso Diário (11h)',
    stopDailyRestReduced: 'Descanso Diário Reduzido (9h)',
    stopWeeklyRest: 'Descanso Semanal (45h)',
    // Route details
    routeDetails: 'Detalhes da Rota',
    distance: 'Distância',
    duration: 'Duração',
    fuelEstimate: 'Combustível Estimado',
    arrivalTime: 'Chegada Prevista',
    withStops: '(c/ paragens)',
    onTime: 'Dentro do prazo',
    tooEarly: 'Antes do prazo',
    tooLate: 'Fora do prazo',
    timeWindow: 'Janela',
    km: 'km',
    hours: 'h',
    minutes: 'min',
    liters: 'L',
    euDailyLimit: 'Limite Diário EU',
    exceedsLimit: 'Excede limite',
    withinLimit: 'Dentro do limite',
    fuelCosts: 'Custos de Combustível',
    totalEstimatedCost: 'Custo total estimado',
    liveRate: '📡 Taxa ao vivo',
    estimatedRate: '⚠ Taxa estimada',
    fuelTypeLbl: 'Tipo',
    consumptionLbl: 'Consumo',
    costPerKm: 'Custo / km',
    co2Emissions: 'Emissões CO₂',
    alternativeRoutes: 'Rotas Alternativas',
    alternative: 'Alternativa',
    time: 'Tempo',
    useThisRoute: 'Usar esta rota',
    roadType: 'Tipo de Estrada',
    roadMotorway: 'Autoestrada',
    roadHighway: 'IP / IC',
    roadNational: 'Nacional',
    roadLocal: 'Local',
    fullRoute: 'Trajecto Completo',
    segments: 'troços',
    unnamed: 'Sem nome',
    journey: 'Percurso',
    via: 'Via',
    assignment: 'Atribuição',
    // Tachograph
    tachographTitle: 'Tacógrafo (EU 561/2006)',
    driving: 'Condução',
    pause: 'Pausa',
    finalDriving: 'Condução final',
    arrival: 'Chegada',
    departure: 'Partida',
    arrivalWindow: 'Janela de Chegada',
    // Saved routes
    savedRoutesTitle: 'Rotas Gravadas',
    saveCurrentRouteBtn: 'Guardar Rota Atual',
    currentRouteLabel: 'Rota atual:',
    noNameRoute: 'Sem nome',
    importJSON: 'Importar JSON',
    exportAll: 'Exportar Todas',
    exportJSON: 'Exportar JSON',
    noSavedRoutes: 'Nenhuma rota guardada',
    savedRoutesHint: 'Calcule uma rota e clique em "Guardar Rota Atual" ou no ícone 💾 do cabeçalho.',
    loadRouteBtn: 'Carregar Rota',
    activeRouteLabel: '✓ Rota atual',
    invalidJSON: 'Ficheiro JSON inválido.',
    stopSingular: 'paragem',
    stopPlural: 'paragens',
    routeNoName: 'Rota sem nome',
    // Reports
    reports: 'Relatórios',
    exportPDF: 'Exportar PDF',
    exportExcel: 'Exportar Excel',
    sendWhatsApp: 'Enviar WhatsApp',
    print: 'Imprimir',
    routeReport: 'Relatório de Rota',
    nonConformity: 'Relatório de Inconformidades',
    // Status
    calculating: 'A calcular rota...',
    noRoute: 'Sem rota calculada',
    routeReady: 'Rota pronta',
    error: 'Erro ao calcular rota',
    // Actions
    save: 'Guardar',
    edit: 'Editar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    delete: 'Eliminar',
    // Misc
    language: 'Idioma',
    darkMode: 'Modo Escuro',
    enterAddress: 'Morada ou coordenadas (lat,lng)',
    noTokenWarning: 'Token Mapbox não configurado — configure REACT_APP_MAPBOX_TOKEN no ficheiro .env',
    // Mobile preview
    mobilePreview: 'Ver no telemóvel',
    sendToPhone: 'Enviar para Telemóvel',
    sendingToPhone: 'A enviar...',
    sentToPhone: 'Enviado ✓',
    startNavigation: 'Iniciar Navegação',
    routeReceived: 'Rota recebida',
    sentRoute: 'Rota enviada por EcooGPS Planner',
    // Send to vehicle
    sendToVehicle: 'Enviar para Viatura',
    sendToVehicleDesc: 'Enviar rota calculada para uma viatura',
    sentToVehicleLabel: 'Enviada',
    routeInfo: 'Informacao da Rota',
    noVehiclesAvailable: 'Nenhuma viatura disponivel para este cliente',
    selectVehicleToSend: 'Selecione a viatura para onde enviar a rota',
    noVehicle: 'Sem viatura',
    confirmSend: 'Enviar Rota',
    sendingRoute: 'A enviar...',
    routeSentSuccess: 'Rota enviada com sucesso!',
    routeSentToPlate: 'Enviada para a viatura',
    routeMarkedSent: 'Rota marcada como enviada',
    close: 'Fechar',
    // Save route dialog
    routeSaved: 'Rota guardada com sucesso!',
    routeUpdated: 'Rota atualizada com sucesso!',
    updateLabel: 'Atualizar',
    saveRouteNewDesc: 'Confirme os dados antes de guardar',
    saveRouteUpdateDesc: 'Esta rota ja existe e sera atualizada',
    savingRoute: 'A guardar...',
    saveRoute: 'Guardar Rota',
    updateRoute: 'Atualizar Rota',
    // App download
    appDownloadTitle: 'EcooPlannerMobile',
    appDownloadScan: 'Digitalize o QR Code com o seu telemóvel Android para descarregar a aplicação.',
    appDownloadWarning: 'Poderá ter de ativar a instalação de fontes desconhecidas nas definições do dispositivo.',
    appDownloadBtn: 'App Móvel',
    appDownloadTooltip: 'Descarregar App Móvel',
    actionsMenu: 'Ações',
    sendRouteToApp: 'Enviar Rota para a App',
    sendRouteToAppDesc: 'Enviar a rota calculada para a app móvel',
    downloadAppDesc: 'Descarregar a aplicação móvel',
    saveRouteDesc: 'Guardar a rota no servidor',
    sendToVehicleDesc: 'Enviar a rota para a viatura',
    // Vehicle/Driver form
    searchVehiclePlaceholder: 'Pesquisar matrícula ou tipo...',
    noVehicleFound: 'Nenhum veículo encontrado',
    clear: 'Limpar',
    baseConsumption: 'Consumo base',
    searchDriverPlaceholder: 'Pesquisar nome...',
    noDriverFound: 'Nenhum motorista encontrado',
    manageVehicles: 'Gerir veículos',
    manageDrivers: 'Gerir motoristas',
    name: 'Nome',
    phone: 'Telefone',
    fuelSection: 'Combustível',
    fuelTypeLabel: 'Tipo de combustível',
    consumptionPer100: 'Consumo / 100km',
    fuelPriceLabel: 'Preço',
    pricePerCountry: 'Ver painel direito',
    co2Label: 'CO₂ (kg/L)',
    // Fuel types
    fuelDieselShort: 'Gasóleo',
    fuelGasolineShort: 'Gasolina',
    fuelGNL: 'GNL',
    fuelElectric: 'Eléctrico',
    // Route markers
    routeMarkers: 'Locais de Interesse',
    markerSafe: 'Local Seguro',
    markerOvernight: 'Local para Pernoitar',
    markerPoi: 'Local de Interesse',
    markerFuel: 'Local para Abastecer',
    favorites: 'Favoritos',
    allFavorites: 'Todos os Favoritos',
    nearbyFavorites: 'Favoritos Próximos',
    addToRouteAsWaypoint: 'Adicionar à rota como ponto intermédio',
    noFavorites: 'Sem favoritos guardados',
    avoidTunnels: 'Túneis',
    avoidTunnelsTip: 'Evita túneis no percurso. Útil para mercadorias perigosas ou veículos de grandes dimensões.',
    // Manage panel
    manage: 'Gerir',
    manageDesc: 'Gerir rotas e despachos',
    manageRoutes: 'Rotas',
    manageLocations: 'Locais',
    selectRoutesMap: 'Selecione até 5 rotas para visualizar no mapa',
    dispatch: 'Despacho',
    dispatchRoutes: 'Despachar Rotas',
    confirmDispatch: 'Confirmar Despacho',
    availableRoutes: 'Rotas disponíveis',
    dragRoutesHere: 'Arraste rotas para aqui',
    noRoutesToDispatch: 'Nenhuma rota por despachar',
    drivers: 'Motoristas',
    deleteSelected: 'Eliminar Selecionadas',
    noRoutesToManage: 'Nenhuma rota guardada para gerir',
    routesSelected: 'rotas selecionadas',
    confirmDeleteRoutes: 'Tem certeza que deseja eliminar as rotas selecionadas?',
    routesDeleted: 'Rotas eliminadas com sucesso',
    routesSentToApp: 'Rotas enviadas para a app',
    maxRoutesWarning: 'Máximo de 5 rotas no mapa',
    viewRouteDetails: 'Ver Detalhes',
    closeDetails: 'Fechar Detalhes',
    routeWaypoints: 'Pontos Intermédios',
    routeStopsInfo: 'Paragens Obrigatórias',
    routeMarkersList: 'Marcadores',
    routePoisList: 'Pontos de Interesse',
    routeFuelInfo: 'Combustível',
    routeOptionsInfo: 'Opções da Rota',
    noWaypoints: 'Sem pontos intermédios',
    noPois: 'Sem POIs',
    noMarkers: 'Sem marcadores',
    sentYes: 'Sim',
    sentNo: 'Não',
    sentStatus: 'Enviada',
    // Manage - search/filters/pagination
    searchRoutes: 'Pesquisar rotas...',
    filterByVehicle: 'Filtrar por veículo',
    filterByDriver: 'Filtrar por motorista',
    sortByLabel: 'Ordenar',
    sortByDate: 'Data',
    sortByName: 'Nome',
    sortByDistance: 'Distância',
    noRoutesFound: 'Nenhuma rota encontrada',
    allVehicles: 'Todos os veículos',
    allDrivers: 'Todos os motoristas',
    pageOf: 'de',
    // Manage - route detail costs
    estimatedCosts: 'Custos Estimados',
    fuelCostLabel: 'Combustível',
    tollCostLabel: 'Portagens',
    totalCostLabel: 'Total',
    roadBreakdownLabel: 'Distribuição das Estradas',
    roadBreakdownTotal: 'Percurso total',
    tachographSummary: 'Resumo Tacógrafo',
    totalDrivingTime: 'Tempo de condução',
    totalRestTime: 'Tempo de descanso',
    breakCount: 'Pausas',
    restCount: 'Descansos',
    showOnMap: 'Ver no Mapa',
    // Locations management
    addLocation: 'Adicionar Local',
    editLocation: 'Editar Local',
    locationName: 'Nome do Local',
    locationType: 'Tipo',
    locationAddress: 'Morada',
    locationNotes: 'Notas',
    locationCoords: 'Coordenadas',
    clickMapToSetLocation: 'Clique no mapa para definir · botão direito guarda como favorito',
    noLocations: 'Nenhum local guardado',
    locationSaved: 'Local guardado com sucesso',
    locationSaveError: 'Erro ao guardar local. Verifique os dados e tente novamente.',
    saveLocation: 'Guardar local',
    locationAlreadySaved: 'Local ja guardado',
    other: 'Outro',
    nearbyLocations: 'Locais guardados proximos',
    noNearbyLocations: 'Nenhum local guardado proximo da rota',
    maxDistance: 'Distancia max',
    fromRoute: 'da rota',
    addToRoute: 'Adicionar a rota',
    searchAddress: 'Pesquisar morada',
    searchAddressPlaceholder: 'Ex: Rua da Boavista, Porto',
    manualCoords: 'Inserir coordenadas manualmente',
    searching: 'A pesquisar...',
    noResults: 'Sem resultados',
    typeToSearch: 'Escreva para pesquisar',
    locationDeleted: 'Local eliminado',
    locationUpdated: 'Local atualizado',
    typeSafePoint: 'Porto Seguro',
    typeOvernight: 'Pernoitar',
    typePoi: 'Ponto de Interesse',
    typeFuel: 'Abastecimento',
    typeRestArea: 'Área de Descanso',
    typeWarehouse: 'Armazém',
    typeGarage: 'Base / Garagem',
    typeOther: 'Outros',
    preferred: 'Preferencial',
    savedLocations: 'Locais Guardados',
    useLocation: 'Usar este local',
    createdByLabel: 'Criado por',
    // Tolls
    tollCosts: 'Portagens',
    totalTollCost: 'Custo total de portagens',
    tollFree: 'Sem portagens',
    tollFreeMotorwayNote: 'Esta rota usa autoestradas livres (ex: autovías espanholas A-xx, IP/IC portugueses), que são classificadas como autoestrada mas não têm portagem.',
    tollBooth: 'Portagem',
    tollsLoading: 'A calcular portagens...',
    tollsCached: 'Em cache',
    tollPaymentMethods: 'Pagamento',
    totalTripCost: 'Custo total da viagem',
    // Fuel per country
    fuelByCountry: 'Combustível por País',
    loadingFuelPrices: 'A carregar preços...',
    editPrice: 'Clique para editar preço',
    fuelPricesSource: 'Preços de referência EU',
    // Route status / Planned vs Real
    routeStatus: 'Estado',
    searchDrivers: 'Pesquisar motoristas...',
    // Navigation
    navDashboard: 'Dashboard',
    navPlanner: 'Planeamento',
    navFleet: 'Frota',
    navOrders: 'Ordens',
    navRoutes: 'Rotas',
    navReports: 'Relatórios',
    // Transport Orders
    createOrder: 'Nova Ordem de Serviço',
    editOrder: 'Editar Ordem de Serviço',
    orderNumber: 'N\u00BA Ordem',
    pickup: 'Recolha',
    delivery: 'Entrega',
    cargo: 'Carga',
    cargoWeight: 'Peso (kg)',
    cargoVolume: 'Volume (m\u00B3)',
    cargoPallets: 'Paletes',
    cargoType: 'Tipo Carga',
    agreedPrice: 'Pre\u00E7o Acordado',
    priority: 'Prioridade',
    priorityNormal: 'Normal',
    priorityHigh: 'Urgente',
    priorityLow: 'Baixa',
    assignedRoute: 'Rota Atribu\u00EDda',
    notAssigned: 'N\u00E3o atribu\u00EDda',
    otPending: 'Por Atribuir',
    otAssigned: 'Atribu\u00EDda',
    otInTransit: 'Em Tr\u00E2nsito',
    otDelivered: 'Entregue',
    otCancelled: 'Cancelada',
    // Dashboard
    routesToday: 'Rotas Hoje',
    activeVehicles: 'Veículos Ativos',
    pendingDeliveries: 'Entregas Pendentes',
    totalCosts: 'Custos Totais',
    recentAlerts: 'Alertas Recentes',
    noAlerts: 'Sem alertas',
    quickActions: 'Ações Rápidas',
    newRoute: 'Nova Rota',
    manageFleet: 'Gerir Frota',
    viewReports: 'Ver Relatórios',
    // Fleet
    fleetOverview: 'Frota',
    status: 'Estado',
    location: 'Localização',
    lastUpdate: 'Última Atualização',
    moving: 'Em Movimento',
    idle: 'Parado',
    off: 'Desligado',
    allStatuses: 'Todos os estados',
    searchFleet: 'Pesquisar matrícula, tipo ou motorista...',
    noVehiclesFound: 'Nenhum veículo encontrado',
    speed: 'Velocidade',
    // Documents
    attachDocument: 'Anexar documento',
    documents: 'Documentos',
    documentType: 'Tipo de documento',
    documentCMR: 'CMR',
    documentGuiaRemessa: 'Guia de Remessa',
    documentOutro: 'Outro',
    documentDescription: 'Descrição',
    uploadDocument: 'Carregar documento',
    deleteDocument: 'Eliminar documento',
    documentUploading: 'A carregar...',
    documentUploadError: 'Erro ao carregar documento',
    documentDeleteError: 'Erro ao eliminar documento',
    documentMaxSize: 'Máximo 10MB (PDF, JPG, PNG)',
    noDocuments: 'Sem documentos anexados',
    routeNotSavedForDocs: 'Guarde a rota primeiro para anexar documentos',
  },
  en: {
    appTitle: 'EcooGPS Planner',
    appSubtitle: 'Route Planner',
    headerSaveRoute: 'Save Route',
    headerFullscreen: 'Fullscreen',
    stops: 'Stops',
    tabRoute: 'Route',
    tabVehicle: 'Vehicle / Driver',
    tabStops: 'Stops',
    tabSaved: 'Saved',
    origin: 'Origin',
    destination: 'Destination',
    addWaypoint: 'Add Intermediate Stop',
    waypoint: 'Waypoint',
    calculateRoute: 'Calculate Route',
    clearRoute: 'Clear Route',
    undo: 'Undo',
    routeName: 'Route Name',
    cargoRef: 'Cargo / Delivery Reference',
    departureTime: 'Departure Time',
    routePoints: 'Route Locations',
    routeOriginLabel: 'Route Origin',
    routeDestLabel: 'Destination',
    roundTrip: 'Round Trip',
    clickMapOrigin: 'Click on map to set origin',
    clickMapDestination: 'Click on map to set destination',
    routeOptionsTitle: 'Route Options',
    currencyCosts: 'Cost Currency',
    fuel: 'Fuel',
    fuelDiesel: 'Diesel',
    fuelGasoline: 'Gasoline',
    pricePerLitre: 'Price per litre',
    vehicleTypeLbl: 'Vehicle Type',
    vehicleHGV: 'HGV Truck',
    vehicleCar: 'Car',
    truckDimensions: 'Truck Dimensions',
    avoidSection: 'Avoid',
    avoidTolls: 'Tolls',
    avoidTollsTip: 'Avoids toll roads. May use free motorways when available.',
    avoidFerries: 'Ferry crossings',
    avoidMotorways: 'Motorways / IP',
    avoidMotorwaysTip: 'Avoids motorways and controlled-access highways, regardless of tolls. Route will use national and regional roads.',
    showAltRoutes: 'Show alternative routes',
    showAltRoutesTip: 'Calculates up to 2 alternative routes for comparison.',
    avoidUrbanAreas: 'Avoid urban centres',
    avoidCitiesWarning: 'Avoiding cities can significantly increase travel time',
    recalculate: 'Recalculate',
    selectVehicle: 'Select Vehicle',
    selectDriver: 'Select Driver',
    vehicle: 'Vehicle',
    driver: 'Driver',
    plate: 'Plate',
    type: 'Type',
    capacity: 'Capacity',
    licenseClass: 'License Class',
    tachoCard: 'Tacho Card',
    restStops: 'Rest Stops',
    stopAt: 'Stop at',
    driveTime: 'Drive Time',
    stopDuration: 'Stop Duration',
    estimatedArrival: 'Estimated Arrival',
    euRegulation: 'EU Reg. 561/2006',
    totalDrivingTime: 'Total Driving Time',
    totalRestTime: 'Total Rest Time',
    dailyLimit: 'Daily Limit',
    stopsCount: 'No. Stops',
    kmAtStop: 'Km at stop',
    fetchingAddress: 'Fetching address...',
    calculateForStops: 'Calculate route to see automatic stops',
    basedOnRegulation: 'Based on EU Regulation 561/2006',
    noStopsNeeded: 'No mandatory stops required',
    within430: 'Duration within the 4h30 continuous driving limit',
    regulationNote: 'After 4h30 of driving: mandatory 45min break (or 15min + 30min)',
    stopBreak45: '45min Break',
    stopBreakSplit15: '15min Break',
    stopBreakSplit30: '30min Break',
    stopDailyRest: 'Daily Rest (11h)',
    stopDailyRestReduced: 'Reduced Daily Rest (9h)',
    stopWeeklyRest: 'Weekly Rest (45h)',
    routeDetails: 'Route Details',
    distance: 'Distance',
    duration: 'Duration',
    fuelEstimate: 'Fuel Estimate',
    arrivalTime: 'Estimated Arrival',
    withStops: '(w/ stops)',
    onTime: 'On time',
    tooEarly: 'Too early',
    tooLate: 'Late',
    timeWindow: 'Window',
    km: 'km',
    hours: 'h',
    minutes: 'min',
    liters: 'L',
    euDailyLimit: 'EU Daily Limit',
    exceedsLimit: 'Exceeds limit',
    withinLimit: 'Within limit',
    fuelCosts: 'Fuel Costs',
    totalEstimatedCost: 'Total estimated cost',
    liveRate: '📡 Live rate',
    estimatedRate: '⚠ Estimated rate',
    fuelTypeLbl: 'Type',
    consumptionLbl: 'Consumption',
    costPerKm: 'Cost / km',
    co2Emissions: 'CO₂ Emissions',
    alternativeRoutes: 'Alternative Routes',
    alternative: 'Alternative',
    time: 'Time',
    useThisRoute: 'Use this route',
    roadType: 'Road Type',
    roadMotorway: 'Motorway',
    roadHighway: 'IP / IC',
    roadNational: 'National',
    roadLocal: 'Local',
    fullRoute: 'Full Route',
    segments: 'segments',
    unnamed: 'Unnamed',
    journey: 'Journey',
    via: 'Via',
    assignment: 'Assignment',
    tachographTitle: 'Tachograph (EU 561/2006)',
    driving: 'Driving',
    pause: 'Break',
    finalDriving: 'Final driving',
    arrival: 'Arrival',
    departure: 'Departure',
    arrivalWindow: 'Arrival Window',
    savedRoutesTitle: 'Saved Routes',
    saveCurrentRouteBtn: 'Save Current Route',
    currentRouteLabel: 'Current route:',
    noNameRoute: 'Unnamed',
    importJSON: 'Import JSON',
    exportAll: 'Export All',
    exportJSON: 'Export JSON',
    noSavedRoutes: 'No saved routes',
    savedRoutesHint: 'Calculate a route and click "Save Current Route" or the 💾 icon in the header.',
    loadRouteBtn: 'Load Route',
    activeRouteLabel: '✓ Current route',
    invalidJSON: 'Invalid JSON file.',
    stopSingular: 'stop',
    stopPlural: 'stops',
    routeNoName: 'Unnamed route',
    reports: 'Reports',
    exportPDF: 'Export PDF',
    exportExcel: 'Export Excel',
    sendWhatsApp: 'Send WhatsApp',
    print: 'Print',
    routeReport: 'Route Report',
    nonConformity: 'Non-Conformity Report',
    calculating: 'Calculating route...',
    noRoute: 'No route calculated',
    routeReady: 'Route ready',
    error: 'Error calculating route',
    save: 'Save',
    edit: 'Edit',
    cancel: 'Cancel',
    confirm: 'Confirm',
    delete: 'Delete',
    language: 'Language',
    darkMode: 'Dark Mode',
    enterAddress: 'Address or coordinates (lat,lng)',
    noTokenWarning: 'Mapbox token not configured — set REACT_APP_MAPBOX_TOKEN in .env file',
    // Mobile preview
    mobilePreview: 'View on phone',
    sendToPhone: 'Send to Phone',
    sendingToPhone: 'Sending...',
    sentToPhone: 'Sent ✓',
    startNavigation: 'Start Navigation',
    routeReceived: 'Route received',
    sentRoute: 'Route sent by EcooGPS Planner',
    // Send to vehicle
    sendToVehicle: 'Send to Vehicle',
    sendToVehicleDesc: 'Send calculated route to a vehicle',
    sentToVehicleLabel: 'Sent',
    routeInfo: 'Route Information',
    noVehiclesAvailable: 'No vehicles available for this client',
    selectVehicleToSend: 'Select a vehicle to send the route to',
    noVehicle: 'No vehicle',
    confirmSend: 'Send Route',
    sendingRoute: 'Sending...',
    routeSentSuccess: 'Route sent successfully!',
    routeSentToPlate: 'Sent to vehicle',
    routeMarkedSent: 'Route marked as sent',
    close: 'Close',
    // Save route dialog
    routeSaved: 'Route saved successfully!',
    routeUpdated: 'Route updated successfully!',
    updateLabel: 'Update',
    saveRouteNewDesc: 'Confirm the details before saving',
    saveRouteUpdateDesc: 'This route already exists and will be updated',
    savingRoute: 'Saving...',
    saveRoute: 'Save Route',
    updateRoute: 'Update Route',
    // App download
    appDownloadTitle: 'EcooPlannerMobile',
    appDownloadScan: 'Scan the QR Code with your Android phone to download the application.',
    appDownloadWarning: 'You may need to enable installation from unknown sources in your device settings.',
    appDownloadBtn: 'Mobile App',
    appDownloadTooltip: 'Download Mobile App',
    actionsMenu: 'Actions',
    sendRouteToApp: 'Send Route to App',
    sendRouteToAppDesc: 'Send the calculated route to the mobile app',
    downloadAppDesc: 'Download the mobile application',
    saveRouteDesc: 'Save the route to the server',
    sendToVehicleDesc: 'Send the route to the vehicle',
    // Vehicle/Driver form
    searchVehiclePlaceholder: 'Search plate or type...',
    noVehicleFound: 'No vehicle found',
    clear: 'Clear',
    baseConsumption: 'Base consumption',
    searchDriverPlaceholder: 'Search name...',
    noDriverFound: 'No driver found',
    manageVehicles: 'Manage vehicles',
    manageDrivers: 'Manage drivers',
    name: 'Name',
    phone: 'Phone',
    fuelSection: 'Fuel',
    fuelTypeLabel: 'Fuel type',
    consumptionPer100: 'Consumption / 100km',
    fuelPriceLabel: 'Price',
    pricePerCountry: 'See right panel',
    co2Label: 'CO₂ (kg/L)',
    // Fuel types
    fuelDieselShort: 'Diesel',
    fuelGasolineShort: 'Gasoline',
    fuelGNL: 'LNG',
    fuelElectric: 'Electric',
    // Route markers
    routeMarkers: 'Points of Interest',
    markerSafe: 'Safe Location',
    markerOvernight: 'Overnight Location',
    markerPoi: 'Point of Interest',
    markerFuel: 'Refuelling Location',
    favorites: 'Favorites',
    allFavorites: 'All Favorites',
    nearbyFavorites: 'Nearby Favorites',
    addToRouteAsWaypoint: 'Add to route as waypoint',
    noFavorites: 'No favorites saved',
    avoidTunnels: 'Tunnels',
    avoidTunnelsTip: 'Avoids tunnels on the route. Useful for dangerous goods or oversized vehicles.',
    // Manage panel
    manage: 'Manage',
    manageDesc: 'Manage routes and dispatches',
    manageRoutes: 'Routes',
    manageLocations: 'Locations',
    selectRoutesMap: 'Select up to 5 routes to display on the map',
    dispatch: 'Dispatch',
    dispatchRoutes: 'Dispatch Routes',
    confirmDispatch: 'Confirm Dispatch',
    availableRoutes: 'Available routes',
    dragRoutesHere: 'Drag routes here',
    noRoutesToDispatch: 'No routes to dispatch',
    drivers: 'Drivers',
    deleteSelected: 'Delete Selected',
    noRoutesToManage: 'No saved routes to manage',
    routesSelected: 'routes selected',
    confirmDeleteRoutes: 'Are you sure you want to delete the selected routes?',
    routesDeleted: 'Routes deleted successfully',
    routesSentToApp: 'Routes sent to app',
    maxRoutesWarning: 'Maximum 5 routes on map',
    viewRouteDetails: 'View Details',
    closeDetails: 'Close Details',
    routeWaypoints: 'Waypoints',
    routeStopsInfo: 'Mandatory Stops',
    routeMarkersList: 'Markers',
    routePoisList: 'Points of Interest',
    routeFuelInfo: 'Fuel',
    routeOptionsInfo: 'Route Options',
    noWaypoints: 'No waypoints',
    noPois: 'No POIs',
    noMarkers: 'No markers',
    sentYes: 'Yes',
    sentNo: 'No',
    sentStatus: 'Sent',
    // Manage - search/filters/pagination
    searchRoutes: 'Search routes...',
    filterByVehicle: 'Filter by vehicle',
    filterByDriver: 'Filter by driver',
    sortByLabel: 'Sort',
    sortByDate: 'Date',
    sortByName: 'Name',
    sortByDistance: 'Distance',
    noRoutesFound: 'No routes found',
    allVehicles: 'All vehicles',
    allDrivers: 'All drivers',
    pageOf: 'of',
    // Manage - route detail costs
    estimatedCosts: 'Estimated Costs',
    fuelCostLabel: 'Fuel',
    tollCostLabel: 'Tolls',
    totalCostLabel: 'Total',
    roadBreakdownLabel: 'Road Distribution',
    roadBreakdownTotal: 'Total route',
    tachographSummary: 'Tachograph Summary',
    totalDrivingTime: 'Driving time',
    totalRestTime: 'Rest time',
    breakCount: 'Breaks',
    restCount: 'Rests',
    showOnMap: 'Show on Map',
    // Locations management
    addLocation: 'Add Location',
    editLocation: 'Edit Location',
    locationName: 'Location Name',
    locationType: 'Type',
    locationAddress: 'Address',
    locationNotes: 'Notes',
    locationCoords: 'Coordinates',
    clickMapToSetLocation: 'Click on the map to set · right-click saves as favorite',
    noLocations: 'No saved locations',
    locationSaved: 'Location saved successfully',
    locationSaveError: 'Error saving location. Please check the data and try again.',
    saveLocation: 'Save location',
    locationAlreadySaved: 'Location already saved',
    other: 'Other',
    nearbyLocations: 'Nearby saved locations',
    noNearbyLocations: 'No saved locations near the route',
    maxDistance: 'Max distance',
    fromRoute: 'from route',
    addToRoute: 'Add to route',
    searchAddress: 'Search address',
    searchAddressPlaceholder: 'E.g.: 123 Main Street, London',
    manualCoords: 'Enter coordinates manually',
    searching: 'Searching...',
    noResults: 'No results',
    typeToSearch: 'Type to search',
    locationDeleted: 'Location deleted',
    locationUpdated: 'Location updated',
    typeSafePoint: 'Safe Point',
    typeOvernight: 'Overnight',
    typePoi: 'Point of Interest',
    typeFuel: 'Refuelling',
    typeRestArea: 'Rest Area',
    typeWarehouse: 'Warehouse',
    typeGarage: 'Base / Garage',
    typeOther: 'Other',
    preferred: 'Preferred',
    savedLocations: 'Saved Locations',
    useLocation: 'Use this location',
    createdByLabel: 'Created by',
    // Tolls
    tollCosts: 'Tolls',
    totalTollCost: 'Total toll cost',
    tollFree: 'Toll free',
    tollFreeMotorwayNote: 'This route uses free motorways (e.g. Spanish autovías A-xx, Portuguese IP/IC), which are classified as motorway but have no tolls.',
    tollBooth: 'Toll booth',
    tollsLoading: 'Calculating tolls...',
    tollsCached: 'Cached',
    tollPaymentMethods: 'Payment',
    totalTripCost: 'Total trip cost',
    // Fuel per country
    fuelByCountry: 'Fuel by Country',
    loadingFuelPrices: 'Loading prices...',
    editPrice: 'Click to edit price',
    fuelPricesSource: 'EU reference prices',
    // Route status / Planned vs Real
    routeStatus: 'Status',
    searchDrivers: 'Search drivers...',
    // Navigation
    navDashboard: 'Dashboard',
    navPlanner: 'Planner',
    navFleet: 'Fleet',
    navOrders: 'Orders',
    navRoutes: 'Routes',
    navReports: 'Reports',
    // Transport Orders
    createOrder: 'New Service Order',
    editOrder: 'Edit Service Order',
    orderNumber: 'Order No.',
    pickup: 'Pickup',
    delivery: 'Delivery',
    cargo: 'Cargo',
    cargoWeight: 'Weight (kg)',
    cargoVolume: 'Volume (m\u00B3)',
    cargoPallets: 'Pallets',
    cargoType: 'Cargo Type',
    agreedPrice: 'Agreed Price',
    priority: 'Priority',
    priorityNormal: 'Normal',
    priorityHigh: 'Urgent',
    priorityLow: 'Low',
    assignedRoute: 'Assigned Route',
    notAssigned: 'Not assigned',
    otPending: 'Unassigned',
    otAssigned: 'Assigned',
    otInTransit: 'In Transit',
    otDelivered: 'Delivered',
    otCancelled: 'Cancelled',
    // Dashboard
    routesToday: 'Routes Today',
    activeVehicles: 'Active Vehicles',
    pendingDeliveries: 'Pending Deliveries',
    totalCosts: 'Total Costs',
    recentAlerts: 'Recent Alerts',
    noAlerts: 'No alerts',
    quickActions: 'Quick Actions',
    newRoute: 'New Route',
    manageFleet: 'Manage Fleet',
    viewReports: 'View Reports',
    // Fleet
    fleetOverview: 'Fleet',
    status: 'Status',
    location: 'Location',
    lastUpdate: 'Last Update',
    moving: 'Moving',
    idle: 'Idle',
    off: 'Off',
    allStatuses: 'All statuses',
    searchFleet: 'Search plate, type or driver...',
    noVehiclesFound: 'No vehicles found',
    speed: 'Speed',
    // Documents
    attachDocument: 'Attach document',
    documents: 'Documents',
    documentType: 'Document type',
    documentCMR: 'CMR',
    documentGuiaRemessa: 'Delivery Note',
    documentOutro: 'Other',
    documentDescription: 'Description',
    uploadDocument: 'Upload document',
    deleteDocument: 'Delete document',
    documentUploading: 'Uploading...',
    documentUploadError: 'Error uploading document',
    documentDeleteError: 'Error deleting document',
    documentMaxSize: 'Max 10MB (PDF, JPG, PNG)',
    noDocuments: 'No documents attached',
    routeNotSavedForDocs: 'Save the route first to attach documents',
  },
};

export const t = (lang, key) => {
  const dict = translations[lang] || translations.pt;
  return dict[key] || translations.pt[key] || key;
};

export default translations;
